import React, {Component, useEffect, useRef, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import profile_image from "../../resources/images/layout/profile.png";
import {Button} from "primereact/button";


const MessageDetail = props => {
    const [data, setData] = useState([])
    const [dats, setDats] = useState([])
    const [popup_visible, setPopupVisible] = useState(false)
    const [loadingState, setLoadingState] = useState(false)
    const toast = useRef(null);

    const notifications = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/notifications/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data) {
                            setData(data.result)
                            setDats(data.result)
                        } else {
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    useEffect(() => {
        notifications();

    }, [])
    const confirmation = (notf_id, user_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        headers["Authorization"] = `Token ${token}`;
        const bodys = {
            'notf_id': notf_id,
            'situation': 1,
            'user_id': user_id
        }
        const body = JSON.stringify(bodys);
        if (notf_id) {
            fetch("/api/notifications/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data.result) {
                            notifications()
                            setPopupVisible(false)
                            // setData(data.result)
                        } else {
                            setPopupVisible(false)
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setPopupVisible(false)
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setPopupVisible(false)
                        setLoadingState(false);
                        throw res.data;

                    }
                })
        }
    }

    const reject = (notf_id, user_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        const bodys = {
            'notf_id': notf_id,
            'situation': 0,
            'user_id': user_id
        }
        headers["Authorization"] = `Token ${token}`;
        const body = JSON.stringify(bodys);
        if (notf_id) {
            fetch("/api/notifications/", {headers, method: "PUT", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false)
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data.result) {
                            notifications()
                            setPopupVisible(false)
                        } else {
                            setPopupVisible(false)
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setPopupVisible(false)
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setPopupVisible(false)
                        setLoadingState(false);
                        throw res.data;

                    }
                })
        }
    }

    const confirmationButton = (datas) => {
        return (
            <div className="p-grid">

                <div className="p-col-fixed p-col-align-center">
                    <Button icon="pi pi-check" className="p-button-info"
                            onClick={() => confirmation(datas.notf_id, datas.user_id)}/>
                    <Button icon="pi pi-refresh" className="p-button-warning"
                            onClick={() => reject(datas.notf_id, datas.user_id)}/>
                </div>
                {/*<div>*/}
                {/*    <Button title="Onayla" icon="pi pi-check" className="p-button-rounded p-button-text"*/}
                {/*            onClick={() => confirmation(datas.notf_id, datas.user_id)}/>*/}
                {/*    <Button title="Reddet" icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text"*/}
                {/*            onClick={() => reject(datas.notf_id, datas.user_id)}/>*/}
                {/*</div>*/}
            </div>
        );
    }

    return (
        <div className="datatable-responsive-demo">
            <div className="card">
                <DataTable scrollable scrollHeight="200px" value={dats} emptyMessage="Kayıt bulunamadı">
                    <Column field="md_id" header="Id" headerStyle={{width: '8rem', textAlign: 'center'}}
                            bodyStyle={{textAlign: 'center', overflow: 'visible', justifyContent: 'center'}}></Column>
                    <Column field="notf_notification" header="Mesaj"></Column>
                    <Column field="notf_createtime" header="Tarih" style={{width: "250px"}}></Column>
                    <Column header="Onay" body={confirmationButton}
                            style={{width: "150px"}}/>
                    {/*<Column field="cmpt_participationtime" header="Kayıt Tarihi"></Column>*/}
                </DataTable>
            </div>
        </div>
    );

}

export default MessageDetail;



// WEBPACK FOOTER //
// ./src/pages/messageManagement/MessageDetail.jsx